import React from 'react';
import AppLayout from '../components-app/AppLayout';
import OverviewList from '../components-static/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,MobileMenu, LoadGraphic,Step,Segment,SegmentComplete,Dropzone} from '../components-static/Common';
import {EditSizeLabel,EditableBox,EditableSelect,Box,Select,TextButton,Button} from '../components-static/Input';
import u from '../utilities/Utilities';
import PropTypes, { number } from 'prop-types';
import {Spreadsheet} from '../data/Mimetypes';
import {StaffStatus,Passback,YesNoSelect} from '../data/Options';
import '../styles/staff-list.scss';
import moment from 'moment';
import store from 'store';

export default class StaffList extends React.Component{

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        spreadsheetOptions:[],
        addError:"",
        permissions:{},
        selectMode:false,
        groupOptions:[],
        isSuperUser:u.getSuperUser(),
    };

    pageData={
        title:"Users (Employee)",
        permission:"staff",
        url:"/user-list",
        scrollAnchor:u.getKey(),
    };

    listData={
        deleteURL:"/api/delete-staff-entries",
        spreadsheetURL:"/api/generate-staff-spreadsheet",
        overviewURL:"/api/get-all-staff",
        overviewLabel:"user-list",
        orderByField:"staffName",
        orderByType:"ascending",
        numRows:20,
        checkboxPermissions:{},
        listOptions:[
            {label:"Tag Setting",ref:"macro",enabled:true,type:"list"},
        ]
    };

    componentDidMount=()=>{
        this.getPermissionGroupOptions();
        const permissions = u.getPermissions("staff");
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add", mobileLabel:"Add User",ref:"add",image:"/images/page-menu/add.png",title:"Add new user",enabled:(permissions.create==2)},
                {label:"Template", mobileLabel:"Download Template",ref:"download",image:"/images/page-menu/template.png",title:"Download bulk add template",enabled:(permissions.create==2),onClick:this.onDownloadTemplate},
                {label:"Delete", mobileLabel:"Delete User",ref:"delete",image:"/images/page-menu/delete.png",title:"Delete selected user",enabled:(permissions.delete==2)},
                {label:"Spreadsheet", mobileLabel:"Generate Spreadsheet",ref:"spreadsheet",image:"/images/page-menu/spreadsheet.png",title:"Generate spreadsheet from selection",enabled:true},
                {label:"Edit", mobileLabel:"Bulk Edit",ref:"bulkEdit",image:"/images/page-menu/edit.png",title:"Bulk edit selected entries",enabled:(permissions.update==2),padding:"5px"},
                {label:"Print", mobileLabel:"Bulk Print Card",ref:"bulkPrint",image:"/images/page-menu/print-card.png",title:"Bulk print selected entries",enabled:(permissions.create==2),padding:"5px"},
            ]
        })
    };

    onMenuOptionClicked=(ref,show,mobileNav)=>{
        if(mobileNav){
            const toggle = (this.mobileSelect != ref);
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && toggle)});
            this.mobileSelect= ((toggle) ? ref : null);
            for(var i=0; i<mobileNav.length; i++){
                const r = mobileNav[i].ref;
                const show = (r == ref);

                if(show){
                    if(mobileNav[i].onClick){
                        mobileNav[i].onClick();
                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,toggle);
                    }
                    else{
                        this.refs[r].show(toggle);
                    }
                }
                else{
                    if(mobileNav[i].onClick) {

                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,false);
                    }
                    else{
                        this.refs[r].show(false);
                    }
                }
            }
        }
        else{
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && show)});
            this.refs[ref].show(show);
        }
    };

    onToggleForm=(ref,show)=>{
        this.refs['menu'].toggleForm(ref,show);
        this.mobileSelect=(show) ? ref : null;
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    onRefreshList=()=>{
        this.refs['overview'].onRefreshList();
    };

    onContentGrabbed=(content)=>{
        this.setState({spreadsheetOptions:content.spreadsheetOptions});
    };

    onDownloadTemplate=()=>{
        u.post({
            url:"/api/get-add-staff-template",
            data:{},
            success:(callback)=>{
                u.download(callback.filename,callback.filestamp, ()=>{},
                (error,status)=>{
                    console.log(error);
                    this.setState({error:error});
                });
            },
            error:(error,status)=>{
                this.setState({error:error});
            }
        })
    };

    getPermissionGroupOptions=()=>{
        u.post({
            url:"/api/get-permission-group-options",
            data:{},
            success:(groupOptions)=>{
                this.setState({groupOptions:groupOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    render=()=>{
        const mobileMenu = this.state.pageMenuButtons.concat(this.listData.listOptions);
        return (
            <AppLayout title={this.pageData.title} requiredPermission={this.pageData.permission} url={this.pageData.url}>
                <div className="page-error">{this.state.error}</div>
                <PageMenu id={this.pageData.scrollAnchor} title={this.pageData.title} ref="menu" buttons={this.state.pageMenuButtons} onMenuOptionClicked={this.onMenuOptionClicked}>
                    <AddEntry scrollAnchor={this.pageData.scrollAnchor} ref="add" reference="add" onToggleForm={this.onToggleForm} onRefreshList={this.onRefreshList}/>
                    <DeleteListItem scrollAnchor={this.pageData.scrollAnchor} ref="delete" reference="delete" url={this.listData.deleteURL} selected={this.state.selected} onToggleForm={this.onToggleForm} onRefreshList={this.onRefreshList}/>
                    <GenerateSpreadsheet scrollAnchor={this.pageData.scrollAnchor} ref="spreadsheet" url={this.listData.spreadsheetURL} options={this.state.spreadsheetOptions} reference="spreadsheet" selected={this.state.selected} onToggleForm={this.onToggleForm}/>
                    <BulkEdit scrollAnchor={this.pageData.scrollAnchor} ref="bulkEdit" reference="bulkEdit" selected={this.state.selected} onToggleForm={this.onToggleForm} onRefreshList={this.onRefreshList}/>
                    <BulkPrintCard scrollAnchor={this.pageData.scrollAnchor} ref="bulkPrint" reference="bulkPrint" selected={this.state.selected} onToggleForm={this.onToggleForm} onRefreshList={this.onRefreshList}/>
                </PageMenu>
                <OverviewList ref="overview" selectMode={this.state.selectMode} url={this.listData.overviewURL} label={this.listData.overviewLabel} numRows={this.listData.numRows} orderByField={this.listData.orderByField} orderByType={this.listData.orderByType} onSelectChange={this.onSelectChange} registerReference={this.registerReference} onContentGrabbed={this.onContentGrabbed} onMutatedChange={this.onMutatedChange} checkboxPermissions={this.listData.checkboxPermissions}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <StaffItem key={index}
                                           index={index}
                                           content={content}
                                           onChange={onChange}
                                           onContentChange={onContentChange}
                                           registerReference={registerRef}
                                           permissions={this.state.permissions}
                                           groupOptions={this.state.groupOptions}
                                           isSuperUser={this.state.isSuperUser}
                                           />
                            )
                        }
                    }
                </OverviewList>
                <MobileMenu content={mobileMenu} onClick={this.onMenuOptionClicked}/>
            </AppLayout>
        )
    }
}

class StaffItem extends React.Component{

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
    };

    onUnlockPassback=()=>{
        this.setState({loading:true,loadText:"Unlocking passback..."});
        u.post({
            url:"/api/unlock-passback",
            data:{
                type:"staff",
                id:this.props.content.staffID,
                tenantID:this.props.content.tenantID,
            },
            success:()=>{
                this.setState({step:"confirm-remove",loading:false});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        })
    };

    onPrintCard=()=>{
        store.set("staff-card",[this.props.content]);
        window.open("/staff-card?action=print","_blank","width=800,height=800,left=200,top=100");
    };

    render=()=>{
        const content = this.props.content;
        const edit = (this.props.permissions.update == 2);
        const url = "/api/update-staff-info";
        const index = this.props.index+""
        const id = content.staffID;

        return (
            <div style={{textAlign:"center"}}>

                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <div className="list-segment extended" style={{textAlign:"left"}}>
                        <div className="list-segment-item">
                            <div className="list-segment-label">User:</div>
                            <div className="list-segment-input">
                                <EditableBox label="User" field="staffName" values={{value:content.staffName,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                            </div>
                        </div>
                        <div className="list-segment-item">
                            <div className="list-segment-label">Tenant:</div>
                            <div className="list-segment-input">
                                <EditSizeLabel>{content.tenantName}</EditSizeLabel>
                            </div>
                        </div>
                        <div className="list-segment-item">
                            <div className="list-segment-label">Designation:</div>
                            <div className="list-segment-input">
                                <EditableBox label="Designation" field="designation" values={{value:content.designation,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                            </div>
                        </div>
                        <div className="list-segment-item">
                            <div className="list-segment-label">Permission Group:</div>
                            <div className="list-segment-input">
                                  <EditableSelect label="Permission Group" field="permissionGroup" values={{value:content.permissionGroup,enabled:edit,options:this.props.groupOptions}} rules={{required:true,nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                            </div>
                        </div>
                        <div className="list-segment-item">
                            <div className="list-segment-label">Status:</div>
                            <div className="list-segment-input">
                                <EditableSelect label="Status" field="status" values={{value:content.status,enabled:edit,options:[{value:"Active",label:"Active"},{value:"Inactive",label:"Inactive"}]}} rules={{required:true}} id={id} index={index} url={url} onChange={this.props.onChange}/>
                            </div>
                        </div>
                        <div className="list-segment-item">
                            <div className="list-segment-label">Employee ID:</div>
                            <div className="list-segment-input">
                                <EditableBox label="Employee ID" field="employeeID" values={{value:content.employeeID,enabled:edit}} rules={{required:false}} id={id} index={index} url={url} onChange={this.props.onChange}/>
                            </div>
                        </div>
                    </div>

                    <div className="list-segment extended" style={{textAlign:"left"}}>
                        <div className="list-segment-item">
                            <div className="list-segment-label">Contact Number:</div>
                            <div className="list-segment-input">
                                <EditableBox label="Contact Number" field="contactNumber" values={{value:content.contactNumber,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                            </div>
                        </div>
                        <div className="list-segment-item">
                            <div className="list-segment-label">Email:</div>
                            <div className="list-segment-input">
                                <EditableBox label="Email" field="email" type="email" values={{value:content.email,enabled:edit}} rules={{required:true,nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                            </div>
                        </div>
                        <div className="list-segment-item">
                            <div className="list-segment-label">Registered On:</div>
                            <div className="list-segment-input">
                                <EditSizeLabel>{moment(content.registeredOn).format("DD MMM YYYY")}</EditSizeLabel>
                            </div>
                        </div>
                        <div className="list-segment-item">
                            <div className="list-segment-label">Last Entered:</div>
                            <div className="list-segment-input">
                                <EditSizeLabel>{(content.lastEntered) ? moment(content.lastEntered).format("DD MMM YYYY") : "None"}</EditSizeLabel>
                            </div>
                        </div>
                        <div className="list-segment-item">
                            <div className="list-segment-label">Current Location:</div>
                            <div className="list-segment-input">
                                <EditSizeLabel>{content.location}</EditSizeLabel>
                            </div>
                        </div>
                    </div>

                    <div className="list-segment-buttons">
                        {
                            (this.props.isSuperUser)
                                ?
                                <Button type="medium" onClick={()=>{this.setState({step:"remove-passback"})}}>Unlock Anti-Passback</Button>
                                :
                                ""
                        }
                    </div>
                </Step>

                <Step active={this.state.step=="remove-passback"}>
                    <div className="list-segment-details" style={{padding:"20px 0"}}>
                        <h2 className="text-negative">Confirm Unlock Anti-Passback</h2>
                        <div>Please ensure that the user has been briefed that he will be locked out of the turnstiles if he does not exit after he enters</div>
                        <div className="list-segment-buttons">
                            <Button type="medium" onClick={()=>{this.setState({step:"view"})}}>Back</Button>
                            <Button type="medium" onClick={this.onUnlockPassback}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="confirm-remove"}>
                    <div className="list-segment-details" style={{padding:"20px 0"}}>
                        <h2 className="text-emphasis">Anti-Passback Unlocked Successfully</h2>
                        <div className="list-segment-button">
                            <Button type="medium" onClick={()=>{this.setState({step:"view"})}}>Back</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{

    state={
        error:"",
        entryData:{},
        tenantOptions:[],
        bulk:false,
    };

    addData={
        addType:0,
        addURL:"/api/add-staff",
        bulkAddURL:"/api/add-bulk-staff"
    };

    componentDidMount=()=>{
        if(u.getSuperUser()){
            this.getTenantOptions();
        }
    }

    getTenantOptions=()=>{
        u.post({
            url:"/api/get-tenant-options",
            data:{},
            success:(tenantOptions)=>{
                tenantOptions.unshift({value:"None",label:""});
                this.setState({tenantOptions:tenantOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    show=(show)=>{
        this.refs[this.props.reference].show(show);
    }

    onChangeEntry=(value,label,index,option)=>{
        let entryData=this.state.entryData;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onAddEntry=()=>{
        this.setState({error:""});
        const inputs = ["tenantID",'email','staffName','contactNumber','designation','employeeID'];
        for(var i=0; i<inputs.length; i++){
            if(this.refs[inputs[i]]){
                const current = this.refs[inputs[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
            }
        }
        if(this.state.bulk){
            this.refs[this.props.reference].onBulkUpload()
        }
        else{
            this.refs[this.props.reference].onValidated(this.state.entryData);
        }
    };

    onComplete=()=>{
        this.setState({error:"",entryData:{}});
    };

    render=()=>{
        const content=this.state.entryData;
        return (
            <AddListItem scrollAnchor={this.props.scrollAnchor} ref={this.props.reference}
                         reference={this.props.reference} addType={this.addData.addType}
                         index={this.addData.addIndex} label={this.addData.label} bulkURL={this.addData.bulkAddURL}
                         filetypes={Spreadsheet} url={this.addData.addURL} onToggleForm={this.props.onToggleForm}
                         onRefreshList={this.props.onRefreshList} onComplete={this.onComplete} additional={{tenantID:this.state.entryData.tenantID}}>
                <div style={{textAlign:"center"}}>
                    <h3>Complete the following to continue</h3>
                    <div className="segment-error">{this.state.error}</div>
                    <div className="segment-content">
                        <div className="segment-margin-area">
                            {
                                (u.getSuperUser())
                                  ?
                                  <div className="segment-full-item" style={{marginBottom:"0"}}>
                                      <div className="segment-item-label">Tenant:</div>
                                      <div className="segment-item-input">
                                          <Select ref="tenantID" label="Tenant" field="tenantID" values={{value:content.tenantID,options:this.state.tenantOptions}} rules={{required:true}} onChange={this.onChangeEntry}/>
                                      </div>
                                  </div>
                                  :
                                  null
                            }
                            {
                              (!this.state.bulk)
                              ?
                              <div>
                                  <div className="segment-full-item">
                                      <div className="segment-item-label">Email:</div>
                                      <div className="segment-item-input">
                                          <Box ref="email" label="Email" type="email" field="email" values={{value:content.email}} rules={{required:true}} onChange={this.onChangeEntry}/>
                                      </div>
                                  </div>
                                  <div className="segment-full-item">
                                      <div className="segment-item-label">Name:</div>
                                      <div className="segment-item-input">
                                          <Box ref="staffName" label="Name" field="staffName" values={{value:content.staffName}} rules={{placeholder:"Optional"}} onChange={this.onChangeEntry}/>
                                      </div>
                                  </div>
                                  <div className="segment-full-item">
                                      <div className="segment-item-label">Contact Number:</div>
                                      <div className="segment-item-input">
                                          <Box ref="contactNumber" label="Contact Number" field="contactNumber" values={{value:content.contactNumber}} rules={{placeholder:"Optional"}} onChange={this.onChangeEntry}/>
                                      </div>
                                  </div>
                                  <div className="segment-full-item">
                                      <div className="segment-item-label">Designation:</div>
                                      <div className="segment-item-input">
                                          <Box ref="designation" label="Designation" field="designation" values={{value:content.designation}} rules={{placeholder:"Optional"}} onChange={this.onChangeEntry}/>
                                      </div>
                                  </div>
                                  <div className="segment-full-item">
                                      <div className="segment-item-label">Employee ID:</div>
                                      <div className="segment-item-input">
                                          <Box ref="employeeID" label="Employeee ID" field="employeeID" values={{value:content.employeeID}} rules={{placeholder:"Optional"}} onChange={this.onChangeEntry}/>
                                      </div>
                                  </div>
                              </div>
                              :
                              null
                            }

                        </div>

                        <div className="segment-margin-area" style={{fontSize:"0.9em"}}>
                            <TextButton onClick={()=>{this.setState({bulk:!this.state.bulk,error:""})}}>Add {(this.state.bulk) ? "Single Entry" : "Bulk Entries"}</TextButton>
                        </div>

                        <div className="segment-margin-area">
                            {
                                (u.isMobileDevice())
                                  ?
                                  <Button type="medium" onClick={()=>{this.props.onToggleForm(this.props.reference,false)}}>Cancel</Button>
                                  :
                                  ""
                            }
                            <Button type="medium" onClick={this.onAddEntry}>{(!this.state.bulk) ? "Add Entry" : "Upload Users"}</Button>
                        </div>
                    </div>
                </div>
            </AddListItem>
        )
    }
}
AddEntry.propTypes={
    scrollAnchor:PropTypes.string,
    onToggleForm:PropTypes.func.isRequired,
    onRefreshList:PropTypes.func.isRequired,
};

class BulkEdit extends React.Component{

    state={
        active:false,
        loading:false,
        step:0,
        field:"",
        options:[
            {value:"status",label:"Status"},
            {value:"passback",label:"Passback"},
            {value:"permissionGroup",label:"Permission Group"},
            {value:"administrator",label:"Set Administrator"},
        ],
        permissionGroupOptions:[],
    };

    show=(show)=>{
        this.setState({active:show});
    }

    componentDidMount=()=>{
        this.getPermissionGroupOptions();
    }

    getPermissionGroupOptions=()=>{
        u.post({
            url:"/api/get-permission-group-options",
            data:{},
            success:(permissionGroupOptions)=>{
                this.setState({permissionGroupOptions:permissionGroupOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onBack=()=>{
        this.setState({step:0,error:"",filename:false,entryCount:false});
    }

    onSelectField=()=>{
        const field = this.refs['field'].validate();
        const numEntries = (this.props.selected.all) ? (this.props.selected.entryCount - this.props.selected.data.length) : this.props.selected.data.length;
        if(numEntries == 0){
            this.setState({error:"Please select at least 1 entry to continue"});
            return 0;
        }
        this.setState({step:1,field:field.value,error:""});
    }

    onSelectBulk=()=>{
        const field = this.refs['field'].validate();
        this.setState({step:3,field:field.value,error:""});
    }

    onSubmit=()=>{
        const numEntries = (this.state.entryCount) ? parseInt(this.state.entryCount) : (this.props.selected.all) ? (this.props.selected.entryCount - this.props.selected.data.length) : this.props.selected.data.length;
        if(numEntries == 0){
            this.setState({error:"Please select at least 1 tenant to perform bulk edit"});
            return 0;
        }

        const value = this.refs[this.state.field].validate();
        if(!value.valid){
            this.setState({error:value.value});
            return 0;
        }

        this.setState({loading:true,error:""});

        u.post({
            url:"/api/staff-bulk-edit",
            data:{
                selected:this.props.selected,
                filename:this.state.filename,
                field:this.state.field,
                value:value.value,
            },
            success:function(e){
                this.setState({loading:false,step:0,error:"",filename:null,entryCount:null});
                this.props.onToggleForm(this.props.reference,false);
                this.props.onRefreshList();
            }.bind(this),
            error:function(error){
                this.setState({loading:false,error:error});
            }.bind(this)
        })
    }

    onCancel=()=>{
        this.setState({filename:false,entryCount:false});
        this.props.onToggleForm(this.props.reference,false);
    }

    onFileAdded=(filename)=>{
        this.setState({loading:true,loadText:"Uploading..." + filename});
    }

    onUploaded=(filename)=>{
        u.post({
            url:"/api/check-bulk-edit-file",
            data:{
                filename:filename
            },
            success:({valid,entryCount,error})=>{
                if(valid){
                    this.setState({step:1,error:"",filename:filename,entryCount:entryCount,loading:false});
                }
                else{
                    this.setState({loading:false,error:error})
                }
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onError=(error)=>{
        this.setState({error:error,loading:false});
    }

    onProgress=(value)=>{
        this.setState({loadText:"Uploading..." + value + "%"});
    }

    render=()=>{
        const entries = (this.state.entryCount) ? this.state.entryCount : ((this.props.selected.all) ? (this.props.selected.entryCount - this.props.selected.data.length) : this.props.selected.data.length);
        return(
            <Segment active={this.state.active} scrollAnchor={this.props.scrollAnchor} align={"center"}>
                <div className="list-add" style={{position:"relative"}}>
                    <div className="segment-title">Bulk Edit</div>
                    <div className="segment-error">{this.state.error}</div>
                    <LoadGraphic active={this.state.loading} text="Updating tenants..."/>
                    <div className="segment-content">
                        <Step active={(this.state.step == 0)}>
                            <h3>Please select the field that you wish to edit:</h3>
                            <div className="segment-content">
                                <div className="segment-half-item">
                                    <div className="segment-item-label">Field:</div>
                                    <div className="segment-item-input"><Select ref="field" label="Field" values={{options:this.state.options}}/></div>
                                </div>
                            </div>
                            <div className="segment-selected"><u>{entries} {(entries==1) ? "entry" : "entries"} selected</u></div>
                            <div className="segment-buttons">
                                <span className="mobile-only"><Button type="medium" onClick={this.onCancel}>Cancel</Button></span>
                                {
                                  (u.getSuperUser())
                                    ?
                                    <Button type="medium" onClick={this.onSelectBulk}>Upload Users</Button>
                                    :
                                    null
                                }
                                <Button type="medium" onClick={this.onSelectField}>Next</Button>
                            </div>
                        </Step>

                        <Step active={(this.state.step == 1)}>
                            <h3>Please select the value to assign to the field:</h3>
                            <div className="segment-content">
                            {
                                (this.state.field == "status")
                                    ?
                                    <div className="segment-half-item">
                                        <div className="segment-item-label">Status:</div>
                                        <div className="segment-item-input"><Select ref="status" label="Status" values={{options:StaffStatus}}/></div>
                                    </div>
                                    :
                                    ""
                            }
                            {
                                (this.state.field == "passback")
                                    ?
                                    <div className="segment-half-item">
                                        <div className="segment-item-label">Turnstile Passback:</div>
                                        <div className="segment-item-input"><Select ref="passback" label="Passback Option" values={{options:Passback}} rules={{required:true}}/></div>
                                    </div>
                                    :
                                    ""
                            }
                            {
                                (this.state.field == "permissionGroup")
                                    ?
                                    <div className="segment-half-item">
                                        <div className="segment-item-label">Permission Group:</div>
                                        <div className="segment-item-input"><Select ref="permissionGroup" label="Permission Group" values={{options:this.state.permissionGroupOptions}}/></div>
                                    </div>
                                    :
                                    ""
                            }
                            {
                                (this.state.field == "administrator")
                                    ?
                                    <div className="segment-half-item">
                                        <div className="segment-item-label">Administrator:</div>
                                        <div className="segment-item-input"><Select ref="administrator" label="Administrator" values={{options:YesNoSelect}}/></div>
                                    </div>
                                    :
                                    ""
                            }
                            </div>
                            <div className="segment-selected"><u>{entries} {(entries==1) ? "entry" : "entries"} selected</u></div>
                            <div className="segment-buttons">
                                <Button type="medium" onClick={this.onBack}>Back</Button>
                                <Button type="medium" onClick={this.onSubmit}>Apply</Button>
                            </div>
                        </Step>

                        <Step active={(this.state.step == 3)}>
                             <Dropzone label="bulkEditDropzone"
                                       accessibleForPreview={false}
                                       onAdded={this.onFileAdded}
                                       onUploaded={this.onUploaded}
                                       onError={this.onError}
                                       onProgress={this.onProgress}
                                       filetypes={Spreadsheet}
                                       dragAndDropLabel="Upload Completed SoilbuildGO User Template (User Email Compulsory)"
                                       />
                              <div className="segment-buttons">
                                  <Button type="medium" onClick={()=>{this.setState({step:0,error:""})}}>Back</Button>
                              </div>
                        </Step>
                    </div>
                </div>
            </Segment>
        )
    }
}

export class BulkAntiPassback extends React.Component{

    state={
        active:false,
        loading:false,
        numberOfEntries:0,
        step:"unlock",
    };

    show=(show)=>{
        this.setState({active:show});
    }

    onUnlock=()=>{
        const entries = (this.props.selected.all) ? (this.props.selected.entryCount - this.props.selected.data.length) : this.props.selected.data.length;
        if(entries == 0){
            this.setState({error:"Please select at least 1 entry to unlock"});
            return 0;
        }

        this.setState({error:"",loading:true});
        u.post({
            url:"/api/bulk-unlock-passback",
            data:{
                type:this.props.type,
                selected:this.props.selected
            },
            success:(numberOfEntries)=>{
                this.setState({step:"success",loading:false,numberOfEntries:numberOfEntries});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        })
    };

    onComplete=()=>{
        this.setState({step:"unlock",error:""});
        this.props.onToggleForm(this.props.reference,false);
    }

    render(){
        const entries = (this.props.selected.all) ? (this.props.selected.entryCount - this.props.selected.data.length) : this.props.selected.data.length;
        return(
            <Segment ref="segment" active={this.state.active} align="center" scrollAnchor={this.props.scrollAnchor}>
                <div className="list-spreadsheet">
                    <div className="segment-title">Unlock Anti-Passback</div>
                    <div className="segment-error">{this.state.error}</div>
                    <Step active={(this.state.step == "unlock")}>
                        <div className="segment-content">
                            <LoadGraphic active={this.state.loading} text="Unlocking entries..."/>
                            <h3>Please select the entries you wish to unlock from the list below</h3>
                            <div className="segment-selected">{entries} {(entries==1) ? "entry" : "entries"} selected</div>
                            <div style={{fontSize:"0.85em",margin:"20px auto"}}>Ensure that the selected users have been briefed on Anti Passback protocols</div>
                            <div className="segment-buttons">
                                <span className="mobile-only"><Button type="medium" onClick={this.onComplete}>Cancel</Button></span>
                                <Button type="medium" onClick={this.onUnlock}>Unlock</Button>
                            </div>
                        </div>
                    </Step>

                    <Step active={(this.state.step == "success")}>
                        <SegmentComplete onComplete={this.onComplete}>
                            Successfully Unlocked {this.state.numberOfEntries} {(this.state.numberOfEntries > 1) ? "Entries" : "Entry"}
                        </SegmentComplete>
                    </Step>

                </div>
            </Segment>
        )
    }
}
BulkAntiPassback.propTypes={
    type:PropTypes.string.isRequired
};

class BulkPrintCard extends React.Component{

    state={
        active:false,
        loading:false,
        step:0,
        cardOptions:[
            {value:"One-Day",label:"One-Day"},
            {value:"Permanent",label:"Permanent"}
        ],
    };

    show=(show)=>{
        this.setState({active:show});
    }

    onBack=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onSubmit=()=>{
        this.setState({error:""});
        const numEntries = (this.props.selected.all) ? (this.props.selected.entryCount - this.props.selected.data.length) : this.props.selected.data.length;
        if(numEntries == 0){
            this.setState({error:"Please select at least 1 user to continue"});
            return 0;
        }

        const passType=this.refs['passType'].validate();
        if(!passType.valid){
            this.setState({error:passType.value});
            return 0;
        }

        this.setState({loading:true,error:""});
        u.post({
            url:"/api/get-selected-staff",
            data:{
                selected:this.props.selected,
                passType:passType.value,
            },
            success:(staff)=>{
                staff = staff.map(
                  (item,index)=>{
                      item.passType = passType.value;
                      return item;
                  }
                )
                store.set("staff-card",staff);
                this.setState({loading:false});
                window.open("/staff-card?action=print","_blank","width=800,height=800,left=200,top=100");
            },
            error:(error)=>{
                this.setState({loading:false,error:error});
            }
        });
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    render=()=>{
        const entries = (this.props.selected.all) ? (this.props.selected.entryCount - this.props.selected.data.length) : this.props.selected.data.length;
        return(
            <Segment active={this.state.active} scrollAnchor={this.props.scrollAnchor} align={"center"}>
                <div className="list-add">
                    <div className="segment-title">Bulk Print Card</div>
                    <div className="segment-error">{this.state.error}</div>
                    <LoadGraphic active={this.state.loading} text="Preparing print preview..."/>
                    <div className="segment-content">
                        <h3>Please select the user to print & card template:</h3>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Pass Type:</div>
                            <div className="segment-item-input">
                                <Select ref="passType" label="Pass Type" values={{options:this.state.cardOptions}} rules={{required:true}}/>
                            </div>
                        </div>
                        <div className="segment-selected"><u>{entries} entries selected</u></div>
                        <div className="segment-buttons">
                            <Button type="medium" onClick={this.onBack}>Cancel</Button>
                            <Button type="medium" onClick={this.onSubmit}>Print</Button>
                        </div>
                    </div>
                </div>
            </Segment>
        )
    }
}
